module.exports = __webpack_public_path__ + "img/trgl-2.05650a35.svg";